(() => {
  if (window.denaOrderTermsReady) return;
  window.denaOrderTermsReady = true;

  const consentSelector = '[data-dena-order-consent]';
  const errorText = 'Veuillez lire et accepter les conditions de commande pour accéder au paiement.';

  function clearError(checkbox) {
    checkbox.removeAttribute('aria-invalid');
    checkbox.setCustomValidity('');
    const error = checkbox.closest('[data-dena-order-terms]')?.querySelector('[data-dena-order-terms-error]');
    if (error) error.hidden = true;
  }

  function resetConsent() {
    document.querySelectorAll(consentSelector).forEach((checkbox) => {
      checkbox.checked = false;
      clearError(checkbox);
    });
  }

  function showError(checkbox) {
    checkbox.setCustomValidity(errorText);
    checkbox.setAttribute('aria-invalid', 'true');
    const error = checkbox.closest('[data-dena-order-terms]')?.querySelector('[data-dena-order-terms-error]');
    if (error) error.hidden = false;
    checkbox.focus();
  }

  function guardCheckout(event) {
    const checkbox = document.querySelector(consentSelector);
    if (checkbox?.checked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkbox) showError(checkbox);
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const checkout = event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (checkout?.form?.id === 'cart') {
      guardCheckout(event);
      return;
    }
    const quantityControl = event.target.closest('cart-items button[name="plus"], cart-items button[name="minus"], cart-remove-button');
    if (quantityControl) resetConsent();
  }, true);

  document.addEventListener('submit', (event) => {
    if (event.target.id !== 'cart') return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    guardCheckout(event);
  }, true);

  document.addEventListener('invalid', (event) => {
    if (!event.target.matches(consentSelector)) return;
    event.preventDefault();
    showError(event.target);
  }, true);

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element)) return;
    if (event.target.matches(consentSelector)) {
      clearError(event.target);
    } else if (event.target.matches('cart-items input[name="updates[]"]')) {
      resetConsent();
    }
  });

  document.addEventListener('input', (event) => {
    if (event.target instanceof Element && event.target.matches('cart-items input[name="updates[]"]')) {
      resetConsent();
    }
  });

  // Dawn replaces cart lines with AJAX. Re-acceptance applies to the resulting cart.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, resetConsent);
  }
  document.addEventListener('cart:lines-update', resetConsent);
  window.addEventListener('pageshow', resetConsent);
  resetConsent();
})();
